import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { getRandomUUID } from '@common/utils/stringUtils';
import { useTranslation } from 'react-i18next';
import Icon from '@stone/ui/icon/Icon';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import ProductImage from '@stone/components/product/ProductImage';
import ProductVideo from '@stone/components/product/ProductVideo';
const ProductTIleVisual = (props) => {
    const { isDesktop } = useMediaQueries();
    const { t } = useTranslation();
    const uuid = useRef(getRandomUUID());
    // STATES
    const [visualToShow, setVisualToShow] = useState(1);
    const [visual1, setVisual1] = useState(null);
    const [visual2, setVisual2] = useState(null);
    const [blockRollover, setBlockRollover] = useState(null);
    const [videoState, setVideoState] = useState('PLAYING');
    //MEMOS
    let lockOnChange = useMemo(() => {
        if (!props.isOver)
            return false;
        return props.isChanged;
    }, [props.isOver, props.isChanged]);
    //CONSTANTS
    const imagePlaceholder = (React.createElement("div", { className: "product-image" },
        React.createElement("img", { alt: '', src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", "aria-hidden": true })));
    //METHODS
    const getVisual = (val, defaultVal) => {
        let isVideo = val.indexOf('V') === 0;
        return {
            type: (isVideo && 'video') || 'image',
            value: val,
            default: defaultVal || val,
        };
    };
    const visualImage = (visual, n, hide) => {
        return (React.createElement("div", { className: classNames('product-image', { hidden: hide }) },
            React.createElement(ProductImage, { productId: props.product.id, onHasImage: (has) => {
                    if (n === 2) {
                        setBlockRollover(!has);
                    }
                }, img: props.product.imgs, tiletype: props.tileType, type: visual.value, onlyImage: true, sizes: props.sizes })));
    };
    const handleButtonState = (id, state) => {
        id === uuid.current && setVideoState(state);
    };
    const renderVideoButton = () => {
        const playOrPause = videoState === 'PAUSED' ? 'play' : 'pause';
        return (React.createElement("button", { className: "product-video-pause", id: uuid.current, "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false" },
            React.createElement(Icon, { family: "16", name: playOrPause }),
            React.createElement("span", null, t('pdp.button.video' + playOrPause))));
    };
    const visualVideo = (visual, n, hide) => {
        //ciclo i videos e verifico la presenza di quello richiesto
        let videoURL = props.product.videos ? Object.values(props.product.videos).find((url) => url.includes(`_${visual.value}`)) : null;
        return videoURL ? (React.createElement("div", { className: classNames('product-tile__image-video', {
                hidden: hide,
            }) },
            React.createElement(ProductVideo, { url: videoURL, overrideButtonID: uuid.current, handleOverrideButtonState: handleButtonState }),
            props.inGallery && renderVideoButton())) : (
        //fallback standard visual image if missing video
        visualImage(visual, n, hide));
    };
    //CALLBACKS
    const printVisual1 = useCallback(() => {
        if (!visual1)
            return imagePlaceholder;
        return visual1.type === 'video' ? visualVideo(visual1, 1, lockOnChange) : visualImage(visual1, 1, lockOnChange);
    }, [visual1, lockOnChange, videoState]);
    const printVisual2 = useCallback(() => {
        if (!visual2)
            return imagePlaceholder;
        return visual2.type === 'video' ? visualToShow == 2 && visualVideo(visual2, 2) : visualImage(visual2, 2, visualToShow != 2);
    }, [visual2, visualToShow, videoState]);
    // EFFECTS
    useEffect(() => {
        const v1 = getVisual(props.customImage || props.visual1, props.visual1);
        const v2 = v1.type != 'video' && getVisual(props.visual2);
        setVisual1(v1);
        if (!(v2 === null || v2 === void 0 ? void 0 : v2.value)) {
            setBlockRollover(true);
        }
        else {
            setVisual2(v2);
        }
    }, [props.product, props.visual1, props.visual2, props.customImage]);
    useEffect(() => {
        if (blockRollover)
            return;
        setVisualToShow(!isDesktop || !props.isOver ? 1 : 2);
    }, [props.isOver, isDesktop, blockRollover]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "overvisual" }, !blockRollover && printVisual2()),
        printVisual1()));
};
ProductTIleVisual.defaultProps = {
    visual1: 'F',
    visual2: 'R',
};
export default ProductTIleVisual;
